import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/home/Hero';
import ServicesOverview from '../components/home/ServicesOverview';
import WhyChooseUs from '../components/home/WhyChooseUs';
import Process from '../components/home/Process';
import Testimonials from '../components/home/Testimonials';
import CTAFooter from '../components/home/CTAFooter';
import PortfolioPreview from '../components/home/PortfolioPreview';
import LatestBlogSection from '../components/home/LatestBlogSection';

const Home = () => {
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "PyrusMedia",
        "image": "https://pyrusmedia.in/logo.svg",
        "url": "https://pyrusmedia.in",
        "telephone": "+917720830178",
        "email": "info@pyrusmedia.in",
        "priceRange": "$$",
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "D408 The Atrium, BG Shirke Rd, Near Magarpatta Mundhwa",
            "addressLocality": "Pune",
            "addressRegion": "Maharashtra",
            "postalCode": "411036",
            "addressCountry": "IN"
        },
        "description": "Leading digital marketing agency in Pune providing custom web development, mobile app development, software solutions, and AI automation services.",
        "sameAs": [
            "https://pyrusmedia.in"
        ]
    };

    return (
        <>
            <Helmet>
                <title>Digital Marketing Agency in Pune & IT Solutions | PyrusMedia</title>
                <meta name="description" content="PyrusMedia is a premier digital marketing agency in Pune offering custom web application development, mobile app development, SEO services, and AI automation solutions." />
                <meta name="keywords" content="digital marketing agency in Pune, digital marketing company, digital agency Pune, digital solutions company, custom digital solutions, PyrusMedia, PyrusMedia Pune" />
                <link rel="canonical" href="https://pyrusmedia.in/" />
                <script type="application/ld+json">
                    {JSON.stringify(schemaData)}
                </script>
            </Helmet>

            <Hero />
            <ServicesOverview />
            <WhyChooseUs />
            <Process />
            <Testimonials />
            <PortfolioPreview />
            <LatestBlogSection />
            <CTAFooter />
        </>
    );
};

export default Home;

